import { render, staticRenderFns } from "./SanityColoredText.vue?vue&type=template&id=383b2529"
import script from "./SanityColoredText.vue?vue&type=script&lang=js"
export * from "./SanityColoredText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports